import React from 'react';
import './AboutUs.css';

import { PageTitle } from '../../../components';
import { About, Testimonials, Counter, Team, Services, Process, Clients, Banner } from '../../../sections';



const AboutUs = () => {

  return (
    <>

      {/* Page title */}
      <PageTitle title={'about us'} page={'about us'} />

      <section className='about-us'>

        <About />
        <Services />
        <Counter />
        <Process />
        <Team />
        <Banner />
        <Testimonials />
        <Clients />

      </section>

    </>
  );
}

export default AboutUs;